
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34086',
  depVersions: {
  "documents-public-ui": "static-1.34086",
  "client-types": "static-1.452",
  "documents-lib": "static-1.34091",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1979",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5444",
  "hs-test-utils": "static-1.7857",
  "hub-http": "static-1.6068",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11292",
  "I18n": "static-7.1585",
  "jasmine-immutable": "static-1.2868",
  "jasmine-runner": "static-1.6321",
  "lodash": "static-1.3",
  "quartz": "static-1.6800",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16501",
  "reporting-data": "static-1.66731",
  "reporting-testing-lib": "static-1.8664",
  "reporting-visualizations": "static-1.58807",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4617",
  "webpack-env": "static-1.54",
  "atom": "static-1.4921",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2343",
  "classnames": "static-2.10",
  "cssUtils": "static-1.750",
  "customer-data-filters-ui": "static-1.39080",
  "customer-data-objects": "static-1.7501",
  "customer-data-property-utils": "static-1.7930",
  "data-fetching-client": "static-1.9528",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4380",
  "flux-actions": "static-1.316",
  "FormsCommonComponents": "static-1.85411",
  "FormUrlGenerator": "static-2.4572",
  "foundations-components": "static-1.7624",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11600",
  "icons": "static-2.630",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7010",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3707",
  "property-translator": "static-1.5261",
  "quartz-config": "static-1.578",
  "quartz-core": "static-1.6019",
  "quick-fetch": "static-1.3785",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5221",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8014",
  "reference-resolvers-lite": "static-1.7934",
  "report-customization-components": "static-1.12654",
  "reporting-enablement": "static-1.22255",
  "reporting-reports": "static-1.66409",
  "reporting-snowflake": "static-1.55349",
  "reporting-ui-components": "static-2.64002",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4488",
  "sales-content-partitioning": "static-1.8786",
  "SalesContentIndexUI": "static-3.8981",
  "sanitize": "static-1.4325",
  "sanitize-text": "static-1.7995",
  "self-service-api": "static-1.10092",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1601",
  "signup-constants": "static-1.18513",
  "signup-ui-lego-core": "static-1.20523",
  "signup-ui-url-generator": "static-2.7884",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4619",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10844",
  "ui-addon-i18n": "static-1.10995",
  "ui-addon-react-router-dom": "static-1.9396",
  "ui-addon-upgrades": "static-9.17732",
  "ui-asset-management-lib": "static-1.10779",
  "ui-images": "static-2.1110",
  "UIComponents": "static-3.8239",
  "usage-tracker": "static-1.7185",
  "usage-tracker-container": "static-1.7175",
  "usage-tracker-core": "static-1.7035",
  "usage-tracker-public": "static-1.6996",
  "viral-links-lib": "static-1.6889",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3275",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3077",
  "quartz-webpack": "static-1.3024",
  "ai-components-ui-library": "static-1.8493",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4691",
  "foundations-theming": "static-1.4263",
  "quartz-auth": "static-1.475",
  "ui-business-units-lib": "static-1.8883",
  "usage-tracker-session-replay": "static-1.4871",
  "foundations-theming-base": "static-1.3248",
  "HeadJS": "static-2.723",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2968",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4177",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7775",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3466",
  "persist-promise": "static-1.3558",
  "reporting-client-types": "static-1.2395",
  "foundations-components-legacy": "static-1.649",
  "hs-story-utils": "static-1.9277",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9594",
  "hubspotter-http": "static-1.4525",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7098",
  "crm-message-bus": "static-1.42512",
  "customer-data-filters-ui-msw-helpers": "static-1.21515",
  "customer-data-objects-ui-components": "static-1.12863",
  "customer-data-reference-ui-components": "static-1.12998",
  "customer-data-ui-utilities": "static-1.9675",
  "framework-builder-read-service-client": "static-1.3879",
  "framework-data-schema-quick-fetch": "static-1.6629",
  "framework-data-schema-resolvers": "static-1.6724",
  "inbound-db-properties-service-client": "static-1.3718",
  "multi-account-reference-resolvers": "static-1.826",
  "onboarding-tours": "static-1.16337",
  "reporting-datasets-permissions-lib": "static-1.13202",
  "ui-addon-teams": "static-1.21312",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67776",
  "customer-data-properties": "static-1.50926",
  "forms-ai-lib": "static-1.4082",
  "forms-utils-lib": "static-1.12265",
  "foundations-components-test-utils": "static-1.5107",
  "react-dnd-compat": "static-1.4471",
  "react-tinymce": "static-1.54761",
  "tinymce-config": "static-2.53887",
  "ui-gdpr-components": "static-1.10198",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3893",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1350",
  "ui-fonts": "static-1.554",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.808",
  "mobile-manifest-mixins": "static-1.498",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.465",
  "quartz-i18n": "static-1.475",
  "quartz-routing": "static-1.230",
  "quartz-test": "static-1.475",
  "quartz-tracking": "static-1.179",
  "batch-promise": "static-1.1401",
  "external-options-client-types": "static-1.4030",
  "react-colorpicker": "static-2.10062",
  "copilot-toolkit": "static-1.10662",
  "data-quality-ui-library": "static-1.12444",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6314",
  "reporting-action-components": "static-1.40784",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10041",
  "ui-addon-draggable-compat": "static-2.4105",
  "ui-addon-opt": "static-4.8233",
  "ui-shepherd-react": "static-3.9997",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24868",
  "hubspot-apollo-client": "static-1.4730",
  "sales-templates-service-types-lib": "static-1.4039",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5555",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3951",
  "timezone-utils": "static-2.5094",
  "bender-build-tools": "static-1.2992",
  "chatspot-core": "static-1.20535",
  "chirp-fetch": "static-1.1734",
  "bend-plugin-foundations-theming": "static-1.2746",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9592",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3670",
  "crm-pipelines-api-client-types": "static-1.4012",
  "multi-currency-client-types": "static-1.3562",
  "getting-started-shared-tasks": "static-1.18020",
  "growth-data-modal": "static-1.5210",
  "growth-onboarding-confetti": "static-1.2923",
  "growth-onboarding-next-action-utils": "static-1.1426",
  "navigation-components": "static-1.17437",
  "onboarding-tours-client": "static-1.4551",
  "onboarding-tours-utils": "static-1.403",
  "ui-shepherd-tracker": "static-1.7378",
  "ui-universal-auth": "static-1.8770",
  "user-context": "static-1.4950",
  "cms-field-types": "static-1.4660",
  "content-icons-ui": "static-1.2174",
  "integrations-lib": "static-1.15584",
  "calling-global-api": "static-1.63866",
  "calling-internal-common": "static-1.31150",
  "calling-lifecycle-internal": "static-1.65248",
  "calling-lifecycle-messages": "static-1.57542",
  "commerce-products-lib": "static-1.8988",
  "crm-links": "static-1.6118",
  "file-manager-components": "static-1.23050",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.534",
  "inbounddb-objects-service-types": "static-1.4095",
  "meetings-icalendar-utils-lib": "static-1.483",
  "object-builder-ui-client": "static-1.48164",
  "pipeline-validation-client-types": "static-1.3836",
  "property-value-citations": "static-1.1540",
  "pulse": "static-1.372",
  "smart-property-lib": "static-1.6129",
  "tiered-pricing": "static-1.907",
  "ui-addon-iframeable": "static-1.8898",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19557",
  "tinymce-themes": "static-1.55857",
  "data-token-picker": "static-1.16129",
  "hub-http-contrib": "static-1.2894",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39972",
  "tinymce-plugins": "static-1.57001",
  "ui-addon-sales-email": "static-1.5064",
  "magpie-lib": "static-1.5445",
  "magpie-types": "static-1.4905",
  "simple-logging-lib": "static-1.2901",
  "content-assistance-lib": "static-1.7522",
  "dashboard-lib": "static-1.80831",
  "ExportDialog": "static-6.10238",
  "hubspot-prosemirror": "static-1.17740",
  "hubspot-prosemirror-plugins": "static-1.17732",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8544",
  "campaign-roi-lib": "static-1.8431",
  "feedback-loader": "static-1.28966",
  "apollo-link-hub-http": "static-2.4502",
  "hubspot-apollo-cache": "static-1.189",
  "growth-monetization-service-types": "static-1.4350",
  "nav-client-types": "static-1.2208",
  "purchase-motions-api": "static-1.5558",
  "trials-service-types": "static-1.3751",
  "growth-onboarding-next-action-components": "static-1.1454",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.576",
  "unified-auth-core-lib": "static-1.565",
  "getting-started-shared-tasks-store": "static-1.17138",
  "integrations-error-boundary-lib": "static-1.12999",
  "integrations-tracking-lib": "static-1.5440",
  "native-integrations-shared-strings": "static-1.7638",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10223",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31156",
  "shared-worker-versioning": "static-1.10890",
  "calling-usage-tracker": "static-1.6391",
  "voice-sms-access-library": "static-1.393",
  "customer-data-tracking": "static-1.6733",
  "commerce-permissions": "static-1.613",
  "products-iframe-lib": "static-1.7463",
  "products-ui-components-shared-msw-handlers": "static-1.9976",
  "location-customization-utils-lib": "static-1.8723",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4005",
  "video-components-external": "static-1.10726",
  "video-data-lib": "static-1.34384",
  "directed-graph": "static-1.789",
  "event-emitter": "static-1.798",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5396",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9677",
  "fsm": "static-1.3580",
  "policy-lib": "static-1.6628",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9740",
  "navigation-messaging": "static-1.6764",
  "FileManagerLib": "static-1.38690",
  "NamespacedHubStyle": "static-2.8943",
  "FileManagerCore": "static-1.38549",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12136",
  "layout-dnd-utils": "static-1.11111",
  "react-codemirror": "static-1.10477",
  "ui-addon-emoji-picker": "static-1.9738",
  "ui-brand-identity-lib": "static-1.14242",
  "ui-addon-video-player": "static-1.8547",
  "ui-coaching-tips": "static-1.28076",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23071",
  "EmailSignatureEditor": "static-1.23991",
  "eligibility-engine-service-types": "static-1.3032",
  "universal-page-editor-lib": "static-1.2852",
  "calling-orchestration-schema": "static-1.35170",
  "sales-views-client-types": "static-1.4135",
  "crm-record-cards-service-types": "static-1.3488",
  "content-media-composition-data-lib": "static-1.11649",
  "content-media-compositions": "static-2.15656",
  "media-bridge-lib": "static-1.18650",
  "trellis-story-utils": "static-1.4371",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5685",
  "FileManagerImages": "static-1.36201",
  "video-components": "static-1.12729",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4382",
  "video-embed": "static-1.35218",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67851",
  "layout-data-lib": "static-1.9436",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6432",
  "commerce-tours-lib": "static-1.5799",
  "growth-onboarding-reliability": "static-1.4936",
  "sales-checkout-service-client": "static-1.3518",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21394",
  "sales-email-signature-service-client": "static-1.3694",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21509",
  "outpost": "static-1.4050",
  "advanced-menus-core": "static-1.14891",
  "advanced-menus-lib": "static-1.11860",
  "ui-memberships-settings-lib": "static-1.33583",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14890",
  "simple-menus-lib": "static-1.16407"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34086",
  "client-types": "/client-types/static-1.452",
  "documents-lib": "/documents-lib/static-1.34091",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1979",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5444",
  "hs-test-utils": "/hs-test-utils/static-1.7857",
  "hub-http": "/hub-http/static-1.6068",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11292",
  "I18n": "/I18n/static-7.1585",
  "jasmine-immutable": "/jasmine-immutable/static-1.2868",
  "jasmine-runner": "/jasmine-runner/static-1.6321",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6800",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16501",
  "reporting-data": "/reporting-data/static-1.66731",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8664",
  "reporting-visualizations": "/reporting-visualizations/static-1.58807",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4617",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4921",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2343",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.750",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39080",
  "customer-data-objects": "/customer-data-objects/static-1.7501",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7930",
  "data-fetching-client": "/data-fetching-client/static-1.9528",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4380",
  "flux-actions": "/flux-actions/static-1.316",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85411",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4572",
  "foundations-components": "/foundations-components/static-1.7624",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11600",
  "icons": "/icons/static-2.630",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7010",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3707",
  "property-translator": "/property-translator/static-1.5261",
  "quartz-config": "/quartz-config/static-1.578",
  "quartz-core": "/quartz-core/static-1.6019",
  "quick-fetch": "/quick-fetch/static-1.3785",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5221",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8014",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7934",
  "report-customization-components": "/report-customization-components/static-1.12654",
  "reporting-enablement": "/reporting-enablement/static-1.22255",
  "reporting-reports": "/reporting-reports/static-1.66409",
  "reporting-snowflake": "/reporting-snowflake/static-1.55349",
  "reporting-ui-components": "/reporting-ui-components/static-2.64002",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4488",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8786",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8981",
  "sanitize": "/sanitize/static-1.4325",
  "sanitize-text": "/sanitize-text/static-1.7995",
  "self-service-api": "/self-service-api/static-1.10092",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1601",
  "signup-constants": "/signup-constants/static-1.18513",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20523",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7884",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4619",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10844",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10995",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9396",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17732",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10779",
  "ui-images": "/ui-images/static-2.1110",
  "UIComponents": "/UIComponents/static-3.8239",
  "usage-tracker": "/usage-tracker/static-1.7185",
  "usage-tracker-container": "/usage-tracker-container/static-1.7175",
  "usage-tracker-core": "/usage-tracker-core/static-1.7035",
  "usage-tracker-public": "/usage-tracker-public/static-1.6996",
  "viral-links-lib": "/viral-links-lib/static-1.6889",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3275",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3077",
  "quartz-webpack": "/quartz-webpack/static-1.3024",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8493",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4691",
  "foundations-theming": "/foundations-theming/static-1.4263",
  "quartz-auth": "/quartz-auth/static-1.475",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8883",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4871",
  "foundations-theming-base": "/foundations-theming-base/static-1.3248",
  "HeadJS": "/HeadJS/static-2.723",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2968",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4177",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7775",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3466",
  "persist-promise": "/persist-promise/static-1.3558",
  "reporting-client-types": "/reporting-client-types/static-1.2395",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.649",
  "hs-story-utils": "/hs-story-utils/static-1.9277",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9594",
  "hubspotter-http": "/hubspotter-http/static-1.4525",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7098",
  "crm-message-bus": "/crm-message-bus/static-1.42512",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21515",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12863",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12998",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9675",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3879",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6629",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6724",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3718",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.826",
  "onboarding-tours": "/onboarding-tours/static-1.16337",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13202",
  "ui-addon-teams": "/ui-addon-teams/static-1.21312",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67776",
  "customer-data-properties": "/customer-data-properties/static-1.50926",
  "forms-ai-lib": "/forms-ai-lib/static-1.4082",
  "forms-utils-lib": "/forms-utils-lib/static-1.12265",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5107",
  "react-dnd-compat": "/react-dnd-compat/static-1.4471",
  "react-tinymce": "/react-tinymce/static-1.54761",
  "tinymce-config": "/tinymce-config/static-2.53887",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10198",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3893",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1350",
  "ui-fonts": "/ui-fonts/static-1.554",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.808",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.498",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.465",
  "quartz-i18n": "/quartz-i18n/static-1.475",
  "quartz-routing": "/quartz-routing/static-1.230",
  "quartz-test": "/quartz-test/static-1.475",
  "quartz-tracking": "/quartz-tracking/static-1.179",
  "batch-promise": "/batch-promise/static-1.1401",
  "external-options-client-types": "/external-options-client-types/static-1.4030",
  "react-colorpicker": "/react-colorpicker/static-2.10062",
  "copilot-toolkit": "/copilot-toolkit/static-1.10662",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12444",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6314",
  "reporting-action-components": "/reporting-action-components/static-1.40784",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10041",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4105",
  "ui-addon-opt": "/ui-addon-opt/static-4.8233",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9997",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24868",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4730",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4039",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5555",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3951",
  "timezone-utils": "/timezone-utils/static-2.5094",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "chatspot-core": "/chatspot-core/static-1.20535",
  "chirp-fetch": "/chirp-fetch/static-1.1734",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2746",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9592",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3670",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4012",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3562",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18020",
  "growth-data-modal": "/growth-data-modal/static-1.5210",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2923",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1426",
  "navigation-components": "/navigation-components/static-1.17437",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4551",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.403",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7378",
  "ui-universal-auth": "/ui-universal-auth/static-1.8770",
  "user-context": "/user-context/static-1.4950",
  "cms-field-types": "/cms-field-types/static-1.4660",
  "content-icons-ui": "/content-icons-ui/static-1.2174",
  "integrations-lib": "/integrations-lib/static-1.15584",
  "calling-global-api": "/calling-global-api/static-1.63866",
  "calling-internal-common": "/calling-internal-common/static-1.31150",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65248",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57542",
  "commerce-products-lib": "/commerce-products-lib/static-1.8988",
  "crm-links": "/crm-links/static-1.6118",
  "file-manager-components": "/file-manager-components/static-1.23050",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.534",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4095",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.483",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48164",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3836",
  "property-value-citations": "/property-value-citations/static-1.1540",
  "pulse": "/pulse/static-1.372",
  "smart-property-lib": "/smart-property-lib/static-1.6129",
  "tiered-pricing": "/tiered-pricing/static-1.907",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8898",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19557",
  "tinymce-themes": "/tinymce-themes/static-1.55857",
  "data-token-picker": "/data-token-picker/static-1.16129",
  "hub-http-contrib": "/hub-http-contrib/static-1.2894",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39972",
  "tinymce-plugins": "/tinymce-plugins/static-1.57001",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5064",
  "magpie-lib": "/magpie-lib/static-1.5445",
  "magpie-types": "/magpie-types/static-1.4905",
  "simple-logging-lib": "/simple-logging-lib/static-1.2901",
  "content-assistance-lib": "/content-assistance-lib/static-1.7522",
  "dashboard-lib": "/dashboard-lib/static-1.80831",
  "ExportDialog": "/ExportDialog/static-6.10238",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17740",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17732",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8544",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8431",
  "feedback-loader": "/feedback-loader/static-1.28966",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4502",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.189",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4350",
  "nav-client-types": "/nav-client-types/static-1.2208",
  "purchase-motions-api": "/purchase-motions-api/static-1.5558",
  "trials-service-types": "/trials-service-types/static-1.3751",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1454",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.576",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.565",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17138",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12999",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5440",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7638",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10223",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31156",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10890",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6391",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.393",
  "customer-data-tracking": "/customer-data-tracking/static-1.6733",
  "commerce-permissions": "/commerce-permissions/static-1.613",
  "products-iframe-lib": "/products-iframe-lib/static-1.7463",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9976",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8723",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4005",
  "video-components-external": "/video-components-external/static-1.10726",
  "video-data-lib": "/video-data-lib/static-1.34384",
  "directed-graph": "/directed-graph/static-1.789",
  "event-emitter": "/event-emitter/static-1.798",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5396",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9677",
  "fsm": "/fsm/static-1.3580",
  "policy-lib": "/policy-lib/static-1.6628",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9740",
  "navigation-messaging": "/navigation-messaging/static-1.6764",
  "FileManagerLib": "/FileManagerLib/static-1.38690",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8943",
  "FileManagerCore": "/FileManagerCore/static-1.38549",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12136",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11111",
  "react-codemirror": "/react-codemirror/static-1.10477",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9738",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14242",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8547",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28076",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23071",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23991",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3032",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2852",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35170",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3488",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11649",
  "content-media-compositions": "/content-media-compositions/static-2.15656",
  "media-bridge-lib": "/media-bridge-lib/static-1.18650",
  "trellis-story-utils": "/trellis-story-utils/static-1.4371",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5685",
  "FileManagerImages": "/FileManagerImages/static-1.36201",
  "video-components": "/video-components/static-1.12729",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4382",
  "video-embed": "/video-embed/static-1.35218",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67851",
  "layout-data-lib": "/layout-data-lib/static-1.9436",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6432",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5799",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4936",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3518",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21394",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3694",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21509",
  "outpost": "/outpost/static-1.4050",
  "advanced-menus-core": "/advanced-menus-core/static-1.14891",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11860",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33583",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14890",
  "simple-menus-lib": "/simple-menus-lib/static-1.16407"
}
};
